(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-luxury-guide]').forEach(root => {
      if (root.dataset.luxuryReady) return;
      root.dataset.luxuryReady = 'true';
      const cards = [...root.querySelectorAll('[data-luxury-kind]')];
      const choices = [...root.querySelectorAll('[data-luxury-pick]')];
      const reset = root.querySelector('[data-luxury-reset]');
      const heading = root.querySelector('[data-luxury-heading]');
      const catalog = document.querySelector('main .collection');
      const sticky = catalog?.querySelector('facet-sticky');
      if (catalog && sticky) {
        const observer = new IntersectionObserver(entries => {
          sticky.toggleAttribute('data-luxury-catalog-visible', entries[0].isIntersecting);
        }, {rootMargin:'-150px 0px -120px 0px'});
        observer.observe(catalog);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) observer.disconnect();
        }, {once:true});
      }
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-luxury-pick], [data-luxury-reset]');
        if (!link || !root.contains(link)) return;
        const kind = link.dataset.luxuryPick;
        if (kind && !cards.some(card => card.dataset.luxuryKind === kind)) return;
        cards.forEach(card => { card.hidden = Boolean(kind && card.dataset.luxuryKind !== kind); });
        root.dataset.luxuryCount = cards.filter(card => !card.hidden).length;
        choices.forEach(choice => {
          if (choice.dataset.luxuryPick === kind) choice.setAttribute('aria-current', 'true');
          else choice.removeAttribute('aria-current');
        });
        reset.hidden = !kind;
        heading.textContent = kind ? `${heading.dataset.selectedTitle}: ${link.textContent.trim()}` : heading.dataset.allTitle;
        root.querySelector('[data-luxury-status]').textContent = heading.textContent;
        // Keep the anchor destination as a no-JS fallback.
      });
    });
  };
  initialize();
  if (!window.kkareLuxuryV2EditorBound) {
    window.kkareLuxuryV2EditorBound = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
